// file: client/src/offline/ulid.js
/**
 * MODULE 09 — compact ULID generator (no dependency).
 * 48-bit timestamp + 80 bits of crypto randomness, Crockford base32 — the
 * client-born idempotency key for every offline op (sortable, collision-safe).
 */
const B32 = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

export function ulid(now = Date.now()) {
  let ts = "";
  let t = now;
  for (let i = 0; i < 10; i += 1) {
    ts = B32[t % 32] + ts;
    t = Math.floor(t / 32);
  }
  const rand = new Uint8Array(16);
  crypto.getRandomValues(rand);
  let rs = "";
  for (let i = 0; i < 16; i += 1) rs += B32[rand[i] % 32];
  return ts + rs;
}
